import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".MenuOption-module_MenuOption__0oLT1 {\n  border-bottom: solid 1px #cccccc;\n}\n\n.MenuOption-module_NoBorder__2QHqX {\n  border-bottom: none !important;\n}\n\n.MenuOption-module_MenuOption__0oLT1.MenuOption-module_ButtonRole__Dfcyh:hover {\n  background-color: #fafafa;\n}";
var styles = {"MenuOption":"MenuOption-module_MenuOption__0oLT1","NoBorder":"MenuOption-module_NoBorder__2QHqX","ButtonRole":"MenuOption-module_ButtonRole__Dfcyh"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=MenuOption.module.scss.js.map
